import React from 'react';
import { Images, stripHtml } from 'utils';
import { TextRow, DateRow, EditWithIcon, HtmlConvertor } from 'components';

export const eventHead = (hasPermission) => [
    { name: 'DATE', title: 'Data', disabled: true, width: '140px' },
    { name: 'STAFF', rowName: 'fullName', title: 'Staff', searchKey: 'STAFF', width: '200px' },
    { name: 'REASON', title: 'Reason', searchKey: 'REASON' },
    hasPermission &&
    { name: 'action', title: 'Actions', custom: false, disabled: true, width: '115px' },
];

export const eventBody = (hasPermission) => [
    { rowText: (item) => <DateRow date={item?.eventDate} /> },
    { rowText: (item) => <TextRow name={item?.staff?.fullName} /> },
    { rowText: (item) => <HtmlConvertor text={item?.reason} /> },
    hasPermission && {
        button: (fn) => (
            <div className="flex-align-center" style={{ gap: 16 }}>
                <EditWithIcon handleClick={() => fn('edit')} />
                <EditWithIcon handleClick={() => fn('delete')} icon={Images.redTrash} />
            </div>
        ),
        notClickable: true,
    },
];

export const ACTION_TYPE = 'GET_EVENTS';

export const DELETE_ACTION_TYPE = 'DELETE_EVENT';

export const eventNotYet = {
    title: 'No Events Added Yet',
    subTitle: 'Start by adding events to manage your events',
    image: Images.noClientYet,
};

export const eventOnModel = {
    Goal: 'Goal',
    Target: 'Target',
    Client: 'Client',
};
